// assets/breadcrumb-toggle.js
(() => {
  const MOBILE_MAX = 780;

  // Met l'état initial (hidden/collapsed) dans un <nav.breadcrumb> donné
  function initBreadcrumb(nav) {
    if (!nav) return;
    const collapsed = nav.querySelector('.breadcrumb__list--mobile-collapsed');
    const expanded  = nav.querySelector('.breadcrumb__list--mobile-expanded');
    const toggle    = nav.querySelector('.breadcrumb__toggle');
    if (!collapsed || !expanded || !toggle) return;

    // État initial ARIA + hidden
    toggle.setAttribute('aria-expanded', 'false');

    // Sur mobile, on collapse par défaut (CSS gère l’affichage, mais on synchronise hidden)
    if (window.innerWidth <= MOBILE_MAX) {
      expanded.hidden = true;
      collapsed.hidden = false;
      expanded.classList.remove('show');
    } else {
      // Desktop : on force l’état “expanded” sans transition JS
      expanded.hidden = false;
      collapsed.hidden = true;
      expanded.classList.add('show');
      toggle.setAttribute('aria-expanded', 'true');
    }
  }

  // Initialise tous les breadcrumbs présents dans la page/section
  function initAll(root = document) {
    root.querySelectorAll('nav.breadcrumb').forEach(initBreadcrumb);
  }

  // Délégation : reste active après rerender
  document.addEventListener('click', (e) => {
    const toggle = e.target.closest('.breadcrumb__toggle');
    if (!toggle) return;

    const nav = toggle.closest('nav.breadcrumb');
    if (!nav) return;
    const collapsed = nav.querySelector('.breadcrumb__list--mobile-collapsed');
    const expanded  = nav.querySelector('.breadcrumb__list--mobile-expanded');
    if (!collapsed || !expanded) return;

    // Affiche la liste complète avec transition
    expanded.hidden = false;     // 1) visible mais opacity 0 (CSS)
    collapsed.hidden = true;
    void expanded.offsetWidth;   // 2) reflow pour activer la transition
    expanded.classList.add('show'); // 3) lance la transition
    toggle.setAttribute('aria-expanded', 'true');
  });

  // ESC pour refermer (mobile)
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    const nav = document.querySelector('nav.breadcrumb');
    if (!nav) return;
    const collapsed = nav.querySelector('.breadcrumb__list--mobile-collapsed');
    const expanded  = nav.querySelector('.breadcrumb__list--mobile-expanded');
    const toggle    = nav.querySelector('.breadcrumb__toggle');
    if (!collapsed || !expanded || !toggle) return;

    if (!expanded.hidden) {
      expanded.classList.remove('show');
      // Durée identique à la transition CSS (280ms dans ton script original)
      setTimeout(() => {
        expanded.hidden = true;
        collapsed.hidden = false;
        toggle.setAttribute('aria-expanded', 'false');
      }, 280);
    }
  });

  // Ajuste l’état si on change de breakpoint (mobile <-> desktop)
  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => initAll(document), 100);
  });

  // Bind initial + après chaque swap AJAX
  document.addEventListener('DOMContentLoaded', () => initAll(document));
  document.addEventListener('sections:reloaded', () => initAll(document));
})();
